import React from "react"
import PropTypes from "prop-types"
import Grid from "../../grid"
import Moment from "../../moment"
import { H2, P } from "../../typography"
import { OverviewContainer, IntroVideo, IntroVideoContainer } from "./styles"
import VideoPlayer from "../../video-player"

const Overview = ({
  preferred_name,
  dob,
  programme_age,
  availability_from,
  availability_until,
  course_studied,
  home_number,
  mobile_number,
  email,
  address,
  show_contact_info,
  availability_plugin_enabled,
  video_id,
  video_height,
  video_width,
  student_status
}) => {
  const aspectRatio = video_height / video_width
  const defaultMaxWidth = 250
  const videoWidth = Math.min(defaultMaxWidth, video_width)
  const dynamicHeight = videoWidth * aspectRatio

  return (
    <OverviewContainer>
      <Grid gap="64px" fill>
        <div>
          <H2 variant="primary" profile>
            Basic Information
          </H2>

          <Grid gap="1.5rem" overview videoGrid={!!video_id}>
            {preferred_name && (
              <Grid gap="4px">
                <P variant="content" marginless profileLabel>
                  Preferred name
                </P>
                <P variant="content" marginless profileData>
                  {preferred_name}
                </P>
              </Grid>
            )}

            <Grid gap="4px">
              <P variant="content" marginless profileLabel>
                Date of birth
              </P>
              <P variant="content" marginless profileData>
                <Moment value={dob} blank="-" />
              </P>
            </Grid>

            <Grid gap="4px">
              <P variant="content" marginless profileLabel>
                Age on program
              </P>
              <P variant="content" marginless profileData>
                {programme_age || "-"}
              </P>
            </Grid>

            <Grid gap="4px">
              <P variant="content" marginless profileLabel>
                Course studying/studied
              </P>
              <P variant="content" marginless profileData>
                {course_studied || "-"}
              </P>
            </Grid>

            {availability_plugin_enabled && (
              <Grid gap="4px">
                <P variant="content" marginless profileLabel>
                  Availability
                </P>
                <P variant="content" marginless profileData>
                  {availability_from && availability_until ? (
                    <>
                      <Moment value={availability_from} blank="-" />
                      &nbsp;to&nbsp;
                      <Moment value={availability_until} blank="-" />
                    </>
                  ) : (
                    "-"
                  )}
                </P>
              </Grid>
            )}

            {student_status && (
              <Grid gap="4px">
                <P variant="content" marginless profileLabel>
                  Student status
                </P>
                <P variant="content" marginless profileData>
                  {student_status}
                </P>
              </Grid>
            )}
          </Grid>
        </div>

        {!!show_contact_info && (
          <div>
            <H2 variant="primary" profile>
              Contact information
            </H2>

            <Grid gap="1.5rem" overview videoGrid={true} template="auto / 1fr 1fr 1fr">
              <Grid gap="4px">
                <P variant="content" marginless profileLabel>
                  Home tel
                </P>
                <P variant="content" marginless profileData>
                  {home_number}
                </P>
              </Grid>

              <Grid gap="4px">
                <P variant="content" marginless profileLabel>
                  Mobile/cell
                </P>
                <P variant="content" marginless profileData>
                  {mobile_number}
                </P>
              </Grid>

              <Grid gap="4px">
                <P variant="content" marginless profileLabel>
                  Email
                </P>
                <P variant="content" marginless profileData>
                  {email}
                </P>
              </Grid>

              <Grid gap="4px">
                <P variant="content" marginless profileLabel>
                  Address
                </P>
                <P variant="content" marginless profileData>
                  {address}
                </P>
              </Grid>
            </Grid>
          </div>
        )}
      </Grid>

      {!!video_id && (
        <IntroVideoContainer>
          <IntroVideo width={videoWidth} height={dynamicHeight}>
            <VideoPlayer
              videoId={video_id}
              displayLabel={true}
              fullSize={true}
              width={videoWidth}
              height={dynamicHeight}
            />
          </IntroVideo>
        </IntroVideoContainer>
      )}
    </OverviewContainer>
  )
}

Overview.propTypes = {
  dob: PropTypes.string,
  programme_age: PropTypes.string,
  availability_from: PropTypes.string,
  availability_until: PropTypes.string,
  course_studied: PropTypes.string,
  home_number: PropTypes.string,
  mobile_number: PropTypes.string,
  email: PropTypes.string,
  address: PropTypes.string,
  show_contact_info: PropTypes.bool,
  availability_plugin_enabled: PropTypes.bool
}

Overview.defaultProps = {
  dob: "-",
  programme_age: "-",
  availability_from: "-",
  availability_until: "-",
  course_studied: "-",
  home_number: "-",
  mobile_number: "-",
  email: "-",
  address: "-",
  show_contact_info: false,
  availability_plugin_enabled: false
}

export default Overview
